import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@makeably/creativex-design-system';
import ItemDetails from 'components/internal/review/ItemDetails';
import { NULL_VALUE } from 'components/internal/shared';
import {
  splitSnakeCase,
  titleize,
} from 'utilities/string';
import styles from './ProcessControlDetails.module.css';

const propTypes = {
  record: PropTypes.shape({
    createdAt: PropTypes.string,
    guidelineCheckId: PropTypes.number,
    id: PropTypes.number,
    processControlCheckPassed: PropTypes.bool,
    reviewed: PropTypes.bool,
  }),
};

const defaultProps = {
  record: undefined,
};

const details = [
  {
    key: 'processControlCheckPassed',
    label: 'Accuracy Check Passed',
  },
  {
    key: 'guidelineCheckPassed',
    label: 'Automation Passed',
  },
  {
    key: 'evaluationStrategyName',
    label: 'Automation Type',
  },
  {
    key: 'evaluationStrategyEvaluationCriteria',
    label: 'Automation Criteria',
  },
];

function getPassedIcon(value) {
  switch (value) {
    case true:
      return <Icon color="green" name="checkCircle" noWrapper />;
    default:
      return <Icon color="red" name="xCircle" noWrapper />;
  }
}

function getPassed(value) {
  return {
    element: (
      <div className={styles.passed}>
        { getPassedIcon(value) }
      </div>
    ),
    value: value ?? NULL_VALUE,
  };
}

function getItem({
  evaluationStrategyName,
  guidelineCheckPassed,
  id,
  processControlCheckPassed,
  reviewed,
}) {
  return {
    evaluationStrategyName: { value: evaluationStrategyName },
    guidelineCheckPassed: getPassed(guidelineCheckPassed),
    id: { value: id },
    processControlCheckPassed: getPassed(processControlCheckPassed),
    reviewed: { value: reviewed },
  };
}

function formatCriteria(value, type) {
  switch (type) {
    case 'minimum_area':
      return `${value}%`;
    default:
      return titleize(splitSnakeCase(`${value}`));
  }
}

function renderEvaluationCriteria({
  evaluationStrategyEvaluationCriteria,
}) {
  if (evaluationStrategyEvaluationCriteria === null) return null;

  return (
    Object.entries(evaluationStrategyEvaluationCriteria).map(([type, criteriaValue]) => (
      <>
        <h5>
          { titleize(splitSnakeCase(type)) }
          :
        </h5>
        <div>
          { formatCriteria(criteriaValue, type) }
        </div>
      </>
    ))
  );
}

function ProcessControlDetails({ record }) {
  const isReviewed = record?.reviewed;
  if (!isReviewed) return null;
  const item = useMemo(() => getItem(record), [record]);

  return (
    <>
      <ItemDetails
        columnCount={2}
        details={isReviewed ? details : []}
        item={item}
      />
      <div className={styles.evalutionCriteria}>
        { renderEvaluationCriteria(record) }
      </div>
    </>
  );
}

ProcessControlDetails.propTypes = propTypes;
ProcessControlDetails.defaultProps = defaultProps;

export default ProcessControlDetails;
